export default __webpack_public_path__ + "static/media/logo-pole.192ecd3e.jpg";